import { Box, styled } from '@mui/material';

interface LoaderStyledProps {
  $isFullScreen: boolean;
}

export const LoaderStyled = styled(Box)<LoaderStyledProps>(
  ({ $isFullScreen }) => ({
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    height: $isFullScreen ? '100vh' : '100%',
    '@supports (height: 100dvh)': {
      height: $isFullScreen ? '100dvh' : '100%',
    },
  })
);
